<template>
  <vs-row>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
        <vs-card style="border-radius: 1.5em;">
          <div slot="header">
            <h3 class="card-title mb-0">Datos básicos</h3>
          </div>
          <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <CompanySelector
                  v-model="companyId"/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Fecha inicial</label>
              <vs-input
                  type="date"
                  v-model="initialDate"
                  class="w-100 "/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Fecha final</label>
              <vs-input
                  type="date"
                  v-model="finalDate"
                  class="w-100 "/>
            </vs-col>
          </vs-row>
          <br/>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
              <label class="vs-input--label">Número de factura</label>
              <vs-input
                  type="text"
                  v-model="searchBillNumber"
                  class="w-100 "/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
              <label class="vs-input--label">Estación de pago</label>
              <multiselect v-model="selectedStations"
                           placeholder="Seleccione una estación" label="name"
                           track-by="code"
                           :options="showStations"
                           :multiple="true"
                           :taggable="true"
                           :max-height="150" :max="50">
              </multiselect>
            </vs-col>
          </vs-row>
          <hr class="custom-hr"/>
          <div class="d-inline-block d-md-flex align-items-center">
            <div class="btn-alignment">
              <vs-button
                  :disabled="!isSearch"
                  @click="listInvoices()">Buscar
              </vs-button>
              <vs-button color="gray"
                         @click="clearForm()">Limpiar
              </vs-button>
            </div>
            <div class="ml-auto mt-3 mt-md-0">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                  <vs-button
                      :disabled="!activateCancellation"
                      @click="activePrompt=true">Anular
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-card>
      </vs-col>
      <template>
        <b-modal :active.sync="activePrompt"
                 :width="900"
                 scroll="keep"
                 :on-cancel="closeModal">
          <div class="modal-body"
               style="border-radius: 5em;">
            <vs-row>
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                <vs-card style="border-radius: 1.5em;">
                  <div slot="header">
                    <h2 class="card-title mb-0">Anulación de facturas</h2>
                  </div>
                  <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
                  <vs-row>
                    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                      <div>
                        <vs-table stripe :data="selectedInvoices">
                          <template slot="header">
                            <h3>
                              ¿Está seguro de anular las siguientes facturas?
                            </h3>
                          </template>
                          <template slot="thead">
                            <vs-th>
                              Número
                            </vs-th>
                            <vs-th>
                              Prefijo
                            </vs-th>
                            <vs-th>
                              Impuesto
                            </vs-th>
                            <vs-th>
                              Subtotal
                            </vs-th>
                            <vs-th>
                              Total
                            </vs-th>
                          </template>
                          <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td :data="data[indextr].billNumber">
                                {{ data[indextr].billNumber }}
                              </vs-td>
                              <vs-td :data="data[indextr].prefix">
                                {{ data[indextr].prefix }}
                              </vs-td>
                              <vs-td :data="data[indextr].tax">
                                {{ formatterCurrency(data[indextr].tax) }}
                              </vs-td>

                              <vs-td :data="data[indextr].subtotal">
                                {{ formatterCurrency(data[indextr].subtotal) }}
                              </vs-td>

                              <vs-td :data="data[indextr].total">
                                {{ formatterCurrency(data[indextr].total) }}
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </vs-col>
                    <vs-col vs-lg="12" vs-xs="12">
                      <vs-card style="border-radius: 1.5em;">
                        <div slot="header">
                          <h4 class="card-title mb-0">Descripción de la anulación</h4>
                        </div>
                        <vs-row>
                          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                            <vs-alert :active="descriptionValid" color="danger" icon="new_releases">
                              <span>Debe agregar una <b>descripción</b> para anular la facturación</span>
                            </vs-alert>
                          </vs-col>
                          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                            <vs-textarea
                                v-model="descriptionCancelled"/>
                          </vs-col>
                        </vs-row>
                      </vs-card>
                    </vs-col>
                  </vs-row>
                  <hr class="custom-hr"/>
                  <div class="d-inline-block d-md-flex align-items-center">
                    <div class="ml-auto mt-3 mt-md-0">
                      <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                          <div class="btn-alignment">
                            <vs-button
                                color="danger"
                                @click="closeModal()">Cancelar
                            </vs-button>
                            <vs-button
                                color="primary"
                                @click="invoiceCancellation">Aceptar
                            </vs-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>
          </div>
        </b-modal>
      </template>
      <vs-col vs-lg="12" vs-xs="12">
        <div style="max-height: 25em; overflow-y: auto;">
          <vs-card style="border-radius: 1.5em;">
            <h3 class="card-title d-flex">
              Listado de facturas
            </h3>
            <vs-table
                multiple
                v-model="selectedInvoices"
                :data="invoiceList"
                description
                :description-items="descriptionItems"
                description-title="Registros"
                description-connector=" de "
                description-body="Páginas">
              <template slot="header">
              </template>
              <template slot="thead">
                <vs-th sort-key="billNumber">Número de factura</vs-th>
                <vs-th sort-key="prefix">Prefijo</vs-th>
                <vs-th sort-key="instant">Fecha de la factura</vs-th>
                <vs-th sort-key="tax">Impuesto</vs-th>
                <vs-th sort-key="subtotal">Subtotal</vs-th>
                <vs-th sort-key="total">Total</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].billNumber">
                    {{ data[indextr].billNumber }}
                  </vs-td>
                  <vs-td :data="data[indextr].prefix">
                    {{ data[indextr].prefix }}
                  </vs-td>
                  <vs-td :data="data[indextr].instant">
                    {{ data[indextr].instant }}
                  </vs-td>
                  <vs-td :data="data[indextr].tax">
                    {{ formatterCurrency(data[indextr].tax) }}
                  </vs-td>
                  <vs-td :data="data[indextr].subtotal">
                    {{ formatterCurrency(data[indextr].subtotal) }}
                  </vs-td>
                  <vs-td :data="data[indextr].total">
                    {{ formatterCurrency(data[indextr].total) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination :total="Math.ceil(total/perPage)" :per-page="perPage" v-model="page"/>
          </vs-card>
        </div>
      </vs-col>
    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import multiselect from "vue-multiselect";
import DateUtils from "@/global/DateUtils";
import DeviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import toast from "@/global/ToastConfig";
import invoiceEndpoints from "@/endpoints/billing/InvoiceEndpoints";
import {formatPrice} from "@/global/utils";

export default {
  components: {multiselect, CompanySelector},
  data() {
    return {
      companyId: null,
      initialDate: null,
      finalDate: null,
      searchBillNumber: null,
      selectedStations: [],
      showStations: [],
      isLoading: false,
      invoiceList: [],
      selectedInvoices: [],
      descriptionItems: [],
      activateCancellation: false,
      thereStations: false,
      isSearch: false,
      page: 1,
      perPage: 50,
      total: 0,
      activePrompt: false,
      descriptionCancelled: null,
      descriptionValid: false,
    }
  },
  watch: {
    /**
     * Observa el companyId y realiza una accion si este cambia
     */
    companyId() {
      this.thereStations = false;
      this.descriptionCancelled = null;
      this.invoiceList = [];
      this.showStations = [];
      this.selectedInvoices = [];
      this.selectedStations = [];
      this.page = 1;
      this.validateParams();
    },
    /**
     * Observa el initialDate y realiza una accion si este cambia
     */
    initialDate() {
      this.thereStations = false;
      this.descriptionCancelled = null;
      this.selectedInvoices = [];
      this.invoiceList = [];
      this.showStations = [];
      this.selectedStations = [];
      this.page = 1;
      this.searchBillNumber = null;
      this.validateParams();
    },
    /**
     * Observa el finalDate y realiza una accion si este cambia
     */
    finalDate() {
      this.thereStations = false;
      this.descriptionCancelled = null;
      this.invoiceList = [];
      this.showStations = [];
      this.selectedInvoices = [];
      this.selectedStations = [];
      this.page = 1;
      this.searchBillNumber = null;
      this.validateParams();
    },
    showStations() {
      if (this.showStations.length > 0) {
        this.isSearch = true
        this.thereStations = true;
        this.isLoading = false;
      }
      this.invoiceList = [];
    },
    page() {
      this.listInvoices();
    },
    searchBillNumber() {
      this.page = 1;
    },
    selectedInvoices() {
      this.activateCancellation = this.selectedInvoices.length > 0;
    }
  },
  methods: {
    /**
     * limpia el formulario de busqueda
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.invoiceList = [];
      this.showStations = [];
      this.page = 1;
      this.selectedStations = [];
      this.activateCancellation = false;
      this.thereStations = false;
      this.total = 0;
      this.descriptionCancelled = null;
    },
    /**
     * Metodo que asigna los parametros para descarga y previsualizacion del reporte
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
        page: this.page - 1,
        typeDevices: this.getValidateStations(),
        billsNumber: this.searchBillNumber
      }
    },
    prepareDataCancellation() {
      return {
        companyId: this.companyId,
        description: this.descriptionCancelled
      }
    },
    /**
     * metodo que valida  el fromulario de busqueda
     */
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar  la fecha inicial y/o  la fecha final");
      }
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error(" La fecha final no puede ser inferior a la fecha inicial");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañía");
      }
    },
    /*¨*
       valida los paramertros antes de pulsar borrar
     */
    validateCancellationModal() {
      if (!this.descriptionCancelled || this.descriptionCancelled.trim() === "") {
        this.descriptionValid = true
        throw new Error("Debe agregar una descripción de la anulación");
      }
      this.descriptionValid = false;
    },
    /**
     * metodo que valida si los parametros  de los servicios de traer los
     *  las estaciones son los correctos
     * @returns {Promise<void>}
     */
    validateParams() {
      this.isLoading = true;
      if (!this.companyId) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
      this.listDevices();
    },
    /**
     * metodo que lista las estaciones que facturaron en el rango de fecha ingresado
     * @returns {Promise<void>}
     */
    listDevices() {
      try {
        this.showStations = [];
        this.validateForm();
        const objParams = this.prepareParameters();
        DeviceEndpoint.listByBillingRange(objParams)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                return;
              }
              data.forEach((station) => {
                const unity = {
                  name: station.nickname == null ? station.title : station.nickname,
                  code: station.code,
                };
                this.showStations.push(unity);
              });
            });
        this.forceRender++;
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * Búsca las facturas a mostrar en la tabla
     */
    listInvoices() {
      try {
        this.isLoading = true;
        const params = this.prepareParameters();
        toast.info("Cargando facturación");
        this.validateParams();
        invoiceEndpoints.listInvoiceByCompanyAndDevices(params)
            .then(data => {
              if (data.code <= 0) {
                this.isLoading = false;
                return;
              }
              this.invoiceList = data.info.records;
              this.total = data.info.totalRecords;
              this.isLoading = false;
            })
      } catch (error) {
        toast.error(error.message);
        this.isLoading = false;
      }
    },
    /**
     *  metodo que valida si seleccionaron una estacion o si no que tenga encuenta todas las estaciones
     * @returns {string}
     */
    getValidateStations() {
      return this.selectedStations.length === 0
          ? this.showStations.map(item => item.code).join(",")
          : this.selectedStations.map(item => item.code).join(",")
    },
    /**
     * cierra el modal de confirmacion
     */
    closeModal() {
      this.activePrompt = false;
    },
    /**
     * formatea el valor a moneda colombiana
     * @param value
     * @returns {*}
     */
    formatterCurrency(value) {
      if (isNaN(parseInt(value))) {
        return formatPrice("0")
      }
      return formatPrice(value);
    },
    /***
     * Método que anula la lista de las facturas
     */
    invoiceCancellation() {
      try {
        this.isLoading = true;
        toast.info("Anulando facturación");
        this.validateCancellationModal();
        const dataCancellation = this.prepareDataCancellation();
        invoiceEndpoints.invoiceCancellation(this.selectedInvoices, dataCancellation)
            .then(data => {
              if (data.code > 0) {
                this.selectedInvoices = [];
                this.closeModal();
                this.descriptionCancelled = null;
                this.listInvoices();
              }
              this.isLoading = false;
            })
      } catch (error) {
        toast.error(error.message);
        this.isLoading = false;
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>